import React from "react";
import { ReactComponent as Ticket } from "../../assets/icons/ticket.svg";
import { ReactComponent as Chart } from "../../assets/icons/chart.svg";
import { CommonTicketPhase } from "./FilterAppTicketConstant";
import { ParamKey } from "../../hooks/useQueryParams";
import Route from "./Route";
import { ApproverLevel, UserType } from "./AppUserProfile";

const createPhaseQueryParams = (phase) => {
  const phaseData = {
    id: phase.id,
    name: phase.name,
    value: phase.value,
  };

  return {
    [ParamKey.Phases]: JSON.stringify(phaseData),
    [ParamKey.Statuses]: JSON.stringify(null),
    [ParamKey.Page]: JSON.stringify({ page_id: 1, page_size: 10 }),
  };
};

const ticketPhases = CommonTicketPhase.map((phase) => ({
  id: phase.id.value,
  title: phase.name,
  path: Route.Ticket.View,
  queryParams: createPhaseQueryParams(phase),
  phaseData: {
    id: phase.id,
    value: phase.value,
  },
}));

const createAllTicketsQueryParams = () => {
  return {
    [ParamKey.Phases]: JSON.stringify(null),
    [ParamKey.Statuses]: JSON.stringify(null),
    [ParamKey.Page]: JSON.stringify({ page_id: 1, page_size: 10 }),
  };
};

export const SidebarMenuType = {
  ticket: "all_ticket",
  PowerBI: "power_bi",
};

export const SidebarData = [
  {
    id: SidebarMenuType.ticket,
    title: "คำขอทั้งหมด",
    path: Route.Ticket.View,
    icon: <Ticket className="w-7 h-7" />,
    subMenu: ticketPhases,
    queryParams: createAllTicketsQueryParams(),
    phaseData: { id: "ALL", isSelectAll: true },
  },
  {
    id: SidebarMenuType.PowerBI,
    title: "BI Dashboard",
    icon: <Chart className="w-6 h-6" />,
    path: Route.PowerBi,
    phaseData: null,
    allowRoles: [
      UserType.BUSINESS_CONTROL,
      ApproverLevel.APPROVER_L1,
      ApproverLevel.APPROVER_L2,
      ApproverLevel.APPROVER_L3,
      ApproverLevel.APPROVER_L4,
      ApproverLevel.APPROVER_L5,
    ],
  },
];
